import { useMemo } from 'react';
import { useAppSelector } from '../store/hooks';
import { getPlugins, isDemoPlugin } from './registry';
import type { PluginManifest } from './types';

export function useEnabledPlugins(): PluginManifest[] {
  const allowedIds = useAppSelector((state) => state.auth.user?.plugins);
  const plugins = getPlugins();

  return useMemo(
    () =>
      /**
       * Un plugin DEMO passa senza consultare `user.plugins`. Deliberato: il demo
       * è documentazione eseguibile e non deve dipendere da un'autorizzazione
       * lato Liferay, nemmeno emulata dai mock.
       *
       * Senza questa eccezione sparirebbe proprio dove serve guardarlo: in
       * modalità ibrida (`VITE_USE_MOCK_AUTH=false`, dati finti ma login vero)
       * l'utente arriva davvero dal portale, e il portale non conosce il demo.
       *
       * Non è un buco nell'autorizzazione: un plugin entra in `demoPluginIds`
       * solo passando dalla glob condizionata di `pluginLoader`, che in
       * produzione non esiste — il ramo che la contiene è eliminato a build time.
       */
      plugins.filter((p) => isDemoPlugin(p.id) || allowedIds?.includes(p.id)),
    [plugins, allowedIds]
  );
}
